import { STALE_TIME } from "#app/http/ReactQueryProvider";
import { fetchRecentSearches } from "#modules/search/infra/recentSearches.api";
import { queryKeys } from "#shared/queryKeys/queryKeys";

export const recentSearchesQuery = () => ({
  queryKey: queryKeys.search.recent(),
  queryFn: fetchRecentSearches,
  staleTime: STALE_TIME,
});
